import { render } from "./LogoutEditorCmp.vue?vue&type=template&id=f2784300"
import script from "./LogoutEditorCmp.vue?vue&type=script&lang=js"
export * from "./LogoutEditorCmp.vue?vue&type=script&lang=js"

import "./LogoutEditorCmp.vue?vue&type=style&index=0&id=f2784300&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__